import { message } from 'antd';
import { select, call, put, takeEvery, takeLatest, all, fork } from 'redux-saga/effects'
import { fetchAllGroupsAPI } from '../../services/groups-service';
import { FETCH_ALL_GROUPS, FETCH_ALL_GROUPS_ERROR, FETCH_ALL_GROUPS_SUCCESS } from '../actions/groupsAction';

const getGroupIdForAdmin = state => { return state.auth.authUser.groupIdForAdmin };

function* fetchAllGroups({ }) {
    try {

        const response = yield fetchAllGroupsAPI();

        const groupIdForAdmin = yield select(getGroupIdForAdmin);
        let selectGroups = (response.data.length > 0 && groupIdForAdmin !== null) ? response.data.filter(group => group.groupId === groupIdForAdmin) : [];

        if (response.success) {
            yield put({
                type: FETCH_ALL_GROUPS_SUCCESS,
                groups: selectGroups.length > 0 ? [...selectGroups] : []
            })
        } else {
            yield put({ type: FETCH_ALL_GROUPS_ERROR })
            message.error('Failed to fetch groups!');
        }
    } catch (error) {
        yield put({ type: FETCH_ALL_GROUPS_ERROR, error })
        message.error('Failed to fetch groups!');
    }
}

function* fetchGroupsWatcher() {
    yield takeLatest(FETCH_ALL_GROUPS, fetchAllGroups)
}

export default function* rootSaga() {
    yield all([
        fetchGroupsWatcher(),
    ]);
}